import * as ents from '@attain-apps/entities'

import type * as dms from '../../dms'

import type { Feature } from './feature'
import * as models from './models'

export class Selectors {
  /**
   * List of definitions that are being edited
   */
  public readonly definitionsList

  /**
   * Focused variable definition that is currently being edited
   */
  public readonly focused

  constructor(feature: Feature, schemaFeature: dms.schema.Feature) {
    const _definitionsList = feature.state.project(state => state.definitions)
    this.definitionsList = _definitionsList.project(
      schemaFeature.selectors.schema.asSelector,
      (definitions, schema) =>
        // By default, definition default value is just parsed json received
        // from backend (typed as unknown value). We need to cast each
        // definition value based on the type
        Object.values(definitions).map(definition =>
          models.Definition.castValue(definition, schema),
        ),
    )

    const _focused = feature.state.project(state => state.focused)
    this.focused = _focused.project(
      schemaFeature.selectors.schema.asSelector,
      (focused, schema) => {
        if (focused) {
          // By default, definition default value is just parsed json received
          // from backend (typed as unknown value). We need to cast each
          // definition value based on the type
          const definition = { ...focused.definition }
          return {
            ...focused,
            definition: models.Definition.tryCastValue(definition, schema),
          }
        }
        return undefined
      },
    )
  }
}
